import { useEpcQtdFlag } from './useEpcQtdFlag';

export interface CurvaSPoint {
  data: string;
  pv: number;
  ev: number;
  ac: number;
  eac_proj?: number;
}

export interface CurvaSData {
  points: CurvaSPoint[];
  bac: number;
  eac: number | null;
  cpi: number | null;
}

/**
 * F9.2-X · F1 (locked) — Curva S EPC-QTD desabilitada na UI.
 *
 * Anteriormente lia `emp_vw_evm_contrato` para construir a curva. Sob source
 * lock, retorna sempre `curvaSData = null`. Componentes que precisem de curva
 * devem migrar para a fonte oficial via SAL (`getContractKpis`).
 */
export function useEvmCurvaS(
  _contratoId: string,
  _tipoContratoOperacional?: string,
  _tipoMedicao?: string,
) {
  useEpcQtdFlag();
  return {
    curvaSData: null as CurvaSData | null,
    isLoading: false,
    isEpcQtd: false as const,
  };
}
